import {
  clock,
  messageDelivered,
  messageRead,
  messageSent,
  userIcon,
} from "../../../utility-functions/assetLoader";
import classes from "./Contact.module.css";
const Contact = ({
  name = "",
  phoneNo = "",
  message = "",
  time = "",
  readStatus = "",
  messagesUnread,
  otherContact = false,
  unknownContact = false,
  current = false,
  onClick = () => {},
}) => {

  const getReadStatus = () => {
    switch(readStatus) {
      case "SENT":
        return messageSent();
      case "DELIVERED":
        return messageDelivered();
      case "READ":
        return messageRead();
      case "QUEUED":
        return clock(16, 16)
      default:
        return ""
    }
  }

  return unknownContact ? (
    <div onClick={onClick} className={classes.container}>
      <div className={classes.avatar}>{userIcon()}</div>
      <div className={classes.details}>
        <h6>{phoneNo}</h6>
      </div>
    </div>
  ) : otherContact ? (
    <div
      style={{ backgroundColor: current ? "#F1FCF4" : "#ffffff" }}
      className={classes.container}
      onClick={onClick}
    >
      <div className={classes.avatar}>
        <span>{name?.[0]}</span>
      </div>
      <div className={classes.details}>
        <h6>{name}</h6>
        <span>{phoneNo}</span>
      </div>
    </div>
  ) : (
    <div
      style={{ backgroundColor: current ? "#F1FCF4" : "#ffffff" }}
      className={classes.container}
      onClick={onClick}
    >
      <div className={classes.avatar}>
        <span>{name?.[0]}</span>
      </div>
      <div className={classes.contactDetails}>
        <div className={classes.sec1}>
          <h6>{name}</h6>
          <span style={{ color: messagesUnread ? "#219848" : " #70707b" }}>
            {time}
          </span>
        </div>
        <div className={classes.sec2}>
          <div>
            {readStatus && getReadStatus()}
            <p>{message}</p>
          </div>
          {messagesUnread ? (
            <div className={classes.msgUnread}>
              <span>{messagesUnread}</span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Contact;
